import { Component, HostBinding } from '@angular/core';

@Component({
  standalone: false,
  selector: '[campusTocHeaderImage], campus-toc-header-image',
  template: `<div class="[ frame frame-square frame-contain ] [ corner-inherit ]"><ng-content></ng-content></div>`,
  styleUrls: ['./toc-header-image.component.scss'],
})
export class TocHeaderImageComponent {
  @HostBinding('class')
  defaultClasses = ['block', 'transparent'];
}
